import {ApplicationConfig, ErrorHandler, inject, Injectable} from '@angular/core';
import {provideRouter, withComponentInputBinding} from '@angular/router';

import { routes } from './app.routes';
import {provideHttpClient, withInterceptors} from "@angular/common/http";
import {provideAnimationsAsync} from "@angular/platform-browser/animations/async";
import {providePrimeNG} from "primeng/config";
import Aura from '@primeng/themes/aura';
import {authInterceptor} from "./auth.interceptor";
import {ConfirmationService, MessageService} from "primeng/api";


@Injectable({ providedIn: 'root' })
export class GlobalErrorHandler implements ErrorHandler {
  private readonly messageService = inject(MessageService);

  handleError(error: unknown): void {
    console.error('An error occurred:', error);
    if (error instanceof Error) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: error.message,
        life: 5000
      });
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'An unexpected error occurred.',
        life: 5000
      });
    }
  }
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptors([authInterceptor])),
    provideRouter(routes, withComponentInputBinding()),
    provideAnimationsAsync(),
    MessageService,
    ConfirmationService,
    {provide: ErrorHandler, useClass: GlobalErrorHandler},
    providePrimeNG({
      theme: {
        preset: Aura,
        options:
        {
          darkModeSelector: false,
          darkMode: false,
        }
      }
    })
  ]
};
